import { Box, Flex, Text, useMediaQuery } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import TxtComponent from "./Components/B2CRegistrationComponents/TxtComponent";
import RegistrationProcess from "./Components/B2CRegistrationComponents/RegistrationProcess";
import { Navbar } from "../../Common/Component/Navbar.component";
import { getCompanyByName } from "../../../http";

const B2CRegistrationForm = () => {
  const [isMobile] = useMediaQuery("(max-width: 480px)");
  const [isTab] = useMediaQuery("(max-width: 768px)");
  const [searchParams] = useSearchParams();
  const [companyImageUrl, setCompanyImageUrl] = useState<string | null>(null);
  const [companyData, setCompanyData] = useState<any>(null);
  const [companyLoading, setCompanyLoading] = useState<boolean>(true);
  const [companyError, setCompanyError] = useState<string | null>(null);

  // context is compulsory, planId is optional
  const webContext = searchParams.get("context");
  const planId = searchParams.get("planId") || null;

  useEffect(() => {
    if (!webContext) {
      setCompanyLoading(false);
      setCompanyError("Missing company context. Please use a valid registration link.");
      return;
    }

    fetchCompanyData(webContext);

    async function fetchCompanyData(context: string) {
      setCompanyLoading(true);
      setCompanyError(null);
      try {
        const response = await getCompanyByName(context);
        if (response?.data?.data && response.data.data.length > 0) {
          const company = response.data.data[0];
          setCompanyData(company);
          setCompanyImageUrl(company.logo || null);
        } else {
          setCompanyError("Invalid company. Please check the registration link.");
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
        setCompanyError("Invalid company. Please check the registration link.");
      } finally {
        setCompanyLoading(false);
      }
    }
  }, [webContext]);

  // Show error if no context or company not found
  if (companyError) {
    return (
      <>
        <Navbar />
        <Box
          bgGradient="linear(180deg, #FFF 0%, #D2F0F2 100%)"
          position={"fixed"}
          marginTop={isMobile ? "110px" : "120px"}
          minH={"full"}
          top={0}
          width={"full"}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Text fontSize="18px" fontFamily="Poppins" color="red.500" textAlign="center" px="20px">
            {companyError}
          </Text>
        </Box>
      </>
    );
  }

  // Show loading while fetching company
  if (companyLoading) {
    return (
      <>
        <Navbar />
        <Box
          bgGradient="linear(180deg, #FFF 0%, #D2F0F2 100%)"
          position={"fixed"}
          marginTop={isMobile ? "110px" : "120px"}
          minH={"full"}
          top={0}
          width={"full"}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Text fontSize="16px" fontFamily="Poppins" color="#333">
            Loading...
          </Text>
        </Box>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Box
        bgGradient="linear(180deg, #FFF 0%, #D2F0F2 100%)"
        position={"fixed"}
        marginTop={isMobile ? "110px" : "120px"}
        minH={"full"}
        top={0}
        width={"full"}
      >
        <Flex
          flexDir={isMobile ? "column-reverse" : isTab ? "column" : "row"}
          backgroundImage="url('/Images/image_prev_ui.svg')"
          width={"72%"}
          margin={"auto"}
          height={"auto"}
          justifyContent={isMobile ? "start" : "space-between"}
          alignItems={"center"}
        >
          <Box
            width={isMobile || isTab ? "full" : "auto"}
            textAlign={isMobile || isTab ? "left" : "center"}
            mb={isMobile ? 4 : "56px"}
            mt={isMobile ? "20px" : 0}
          >
            <TxtComponent companyLogo={companyImageUrl} />
          </Box>

          <Box
            width={isMobile ? "full" : "auto"}
            display="flex"
            justifyContent={isMobile ? "center" : "flex-end"}
          >
            <Box>
              {(isMobile || isTab) && companyImageUrl && (
                <Box mb="20px" textAlign="center">
                  <img
                    src={companyImageUrl}
                    alt="Partner Company Logo"
                    style={{ maxHeight: "80px", margin: "0 auto" }}
                  />
                </Box>
              )}
              <RegistrationProcess
                companyData={companyData}
                planId={planId}
              />
            </Box>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default B2CRegistrationForm;
